import React from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Modal, InputText, Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { formatMobileNumberInput } from '../../../../utils/formatNumber';
import { FORM_KEYS } from '../../../../constants/formKeys';
import { useUpdateContactDetails } from './useUpdateContactDetails';
import './updateContactDetailsModal.scss';

export const UpdateContactDetailsPopup = ({
  setShowContactDetailsModal,
  policyHolder,
  setShowSuccessMessage,
  showMobileField = true
}) => {
  const formContext = useFormContext();
  const { email, phoneMobile } = policyHolder;
  const { handleSubmit, handleClose, onInputChange, emailValidation, mobileValidation } = useUpdateContactDetails({
    setShowSuccessMessage,
    setShowContactDetailsModal,
    policyHolder,
    formContext
  });
  return (
    <Modal
      size="small"
      open
      onClose={handleClose}
      header={<h2 className="modal-title">Update my contact details</h2>}
      footer={
        <div className="footerModalContainer">
          <button
            type="button"
            className="button primary outline"
            onClick={handleClose}
          >
            <span className="labelText">Cancel</span>
          </button>

          <button
            type="button"
            className="button primary"
            onClick={handleSubmit}
          >
            <span className="labelText">Update</span>
          </button>
        </div>
      }
    >
      <div className="updateContactDetailsInput">
        {showMobileField && (
          <InputText
            name={FORM_KEYS.NEW_MOBILE_NUMBER}
            label="Mobile number"
            validation={mobileValidation}
            fieldFormContext={formContext}
            defaultValue={formatMobileNumberInput(phoneMobile)}
            customChangeHandler={onInputChange}
          />
        )}
        <InputText
          name={FORM_KEYS.NEW_EMAIL}
          label="Email address"
          validation={emailValidation}
          defaultValue={email}
          fieldFormContext={formContext}
        />
        <div className="updateEmailNotice">
          <Icon
            icon="warning"
            customCssClass="warningIcon"
          />
          <span>
            If you change your email, you may need to re-link your MyPet Portal account to your My Insurance Portal
            using your updated email.
          </span>
        </div>
      </div>
    </Modal>
  );
};

UpdateContactDetailsPopup.propTypes = {
  setShowContactDetailsModal: PropTypes.func,
  setShowSuccessMessage: PropTypes.func,
  showMobileField: PropTypes.bool,
  /* eslint-disable react/forbid-prop-types */
  policyHolder: PropTypes.object
  /* eslint-disable react/forbid-prop-types */
};
